export type ReplaceYoutubeIframeItem = {
  /** Полное HTML-тело iframe */
  iframe: string;
  /** Id ролика */
  id: string;
};

export interface IReplaceYoutubeIframe {
  /** HTML-контент */
  html: string;
  /** Коллекция параметров для ролика */
  items: ReplaceYoutubeIframeItem[];
}

/**
 * 1. Извлекает из HTML все iframe с параметрами
 * 2. Вырезает все iframe из HTML и заменяет пустым div'ом (опционально)
 * @param html - исходный HTML
 * @param replaceHtml - вырезать ли iframe из HTML
 * @returns - Объект с исходным/измененным html и коллекция параметров iframe
 */
export const replaceYoutubeIframe = (html: string, replaceHtml: boolean = false): IReplaceYoutubeIframe => {
  const pattern = /<iframe[^>]*?(?:src="https:\/\/www\.youtube\.com\/embed\/([^?]+)[^"]*?")[^>]*?><\/iframe>/gis;
  const items: ReplaceYoutubeIframeItem[] = [];
  let match;

  if (!html) {
    return {
      html: '',
      items: [] as ReplaceYoutubeIframeItem[],
    };
  }

  while ((match = pattern.exec(html))) {
    items.push({
      iframe: match[0],
      id: match[1],
    });
  }

  return {
    html: replaceHtml
      ? items.reduce((acc, item) => {
          return acc.replace(item.iframe, `<div id="${item.id}"></div>`);
        }, html)
      : html,
    items,
  };
};
